export enum EAppId {
	WEB = 'web',
	WEB_MOBILE = 'web_mobile',
	WEB_VIEW = 'web_view',
	SHARE = 'share',
	SHARE_MOBILE = 'share_mobile',
	UNSET = 'unset',
}
